import {setPageLayout} from '#app';

export default defineNuxtRouteMiddleware(async to => {
  const runtimeConfig = useRuntimeConfig();
  const {public: {appBaseUrl}} = runtimeConfig;
  const appPath = (runtimeConfig.app.baseURL ?? '/').replace(/\/$/, '');
  const origin = appBaseUrl || useRequestURL().origin;
  const currentUrl = `${origin}${appPath}${to.fullPath}`;
  const isSignInRoute = to.path === '/sign_in' || to.path === '/log-in';

  if (!isSignInRoute) {
    const {ensureValidSession} = useAuthGuard();
    await ensureValidSession(currentUrl, {redirect: false});
  }

  const session = useSessionStore();
  const {currentUserInfo, isTokenExpired} = useAuthCookie();
  const userInfo = currentUserInfo();
  const isAuthenticated = Boolean(userInfo?.auth_token) && !isTokenExpired(userInfo);

  if (!isAuthenticated || to.path === '/log-out') {
    setPageLayout('noauth');
  }

  if (!isAuthenticated && to.path === '/log-in') {
    setPageLayout(false);
  }

  else if (!isAuthenticated && to.meta.requiresAuth) {
    const {buildSignInUrl} = useAuthHost();
    const signInUrl = buildSignInUrl(currentUrl);
    return navigateTo(signInUrl, {external: true});
  }

  else if (isAuthenticated && isSignInRoute) {
    return navigateTo(session.currentUser?.landing_path);
  }

  else if (isAuthenticated && !session.isImpersonating && session.currentUser?.account_type === USER_ACCOUNT_TYPES.unspecified.value && to.name !== 'welcome') {
    const preventOnboarding = useCookie('prevent_onboarding').value;
    console.log('[prevent_onboarding]', preventOnboarding);
    if (preventOnboarding) {
      return true;
    }
    return navigateTo({path: '/welcome', query: {redirectTo: to.path}});
  }

  if (to.path.includes('external/embed')) {
    setPageLayout(false);
  }
});
